import ApiRequest from "../utils/ApiRequest";
import { bulkUploadModel } from "../utils/bulkUploadModel";

export default class Illustrator {

  static getAll = async () => {
    return await ApiRequest.set("/v1/illustrators/getall", "GET");
  }

  static getById = async (id) => {
    return await ApiRequest.set(`/v1/illustrators/getbyid/${id}`, "GET");
  }

  static getAllWithPagination = async (limit, page, keyword) => {
    return await ApiRequest.set(`v1/illustrators/admin/get-with-pagination?page=${page}&limit=${limit}&keyword=${keyword}`, "GET")
  }

  static create = async (body) => {
    return await ApiRequest.set("/v1/illustrators/create", "POST", body);
  }

  static edit = async (id, body) => {
    console.log("Body: ", body)
    return await ApiRequest.set(`/v1/illustrators/update/${id}`, "PUT", body);
  }

  static delete = async (id) => {
    return await ApiRequest.set(`v1/illustrators/${id}`, "DELETE");
  }

  static bulkUpload = async (file, dryRun = false) => {
    return await bulkUploadModel('v1/illustrators/').bulkUpload(file, dryRun);
  };

  static downloadTemplate = async () => {
    return await bulkUploadModel('v1/illustrators/').downloadTemplate();
  };
}
